<template>
  <div class="table-responsive">
    <table class="table table-hover">
      <thead class="tw:text-left tw:text-sm tw:bg-zinc-50">
        <tr>
          <th>{{ $t('Date') }}</th>
          <th v-if="showUser">{{ $t('User') }}</th>
          <th>{{ $t('Status') }}</th>
          <th>{{ $t('IP address') }}</th>
          <th class="tw:hidden tw:lg:table-cell tw:print:table-cell">{{ $t('Device') }}</th>
          <th class="tw:hidden tw:sm:table-cell tw:print:table-cell">{{ $t('Session') }}</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="log in logs" :key="log.id">
          <td class="tw:whitespace-nowrap">
            {{ dayjs(log.login_at).format('lll') }}
            <Badge v-if="log.is_suspicious" variant="yellow" size="sm" :title="log.suspicious_reasons.join(' · ')">
              {{ $t('Suspicious') }}
            </Badge>
          </td>

          <td v-if="showUser">
            <div v-if="log.user" class="tw:flex tw:items-center tw:gap-2">
              <UserAvatar :user="log.user" :size="28" />
              <div>
                <a v-if="log.user_edit_url" :href="log.user_edit_url">{{ userName(log.user) }}</a>
                <span v-else>{{ userName(log.user) }}</span>
                <div class="tw:text-xs tw:text-zinc-500">{{ log.user.email }}</div>
              </div>
            </div>
            <span v-else class="tw:text-zinc-400">{{ $t('Deleted user') }}</span>
          </td>

          <td>
            <Badge :variant="log.login_successful ? 'green' : 'red'">
              {{ log.login_successful ? $t('Successful') : $t('Failed') }}
            </Badge>
          </td>

          <td class="tw:whitespace-nowrap tw:font-mono tw:text-xs">{{ log.ip_address }}</td>

          <td class="tw:hidden tw:lg:table-cell tw:print:table-cell" :title="log.user_agent">
            {{ log.device_name || $t('Unknown') }}
          </td>

          <td class="tw:hidden tw:sm:table-cell tw:print:table-cell">
            <Badge v-if="log.is_active" variant="blue">{{ $t('Active') }}</Badge>
            <span v-else-if="log.logout_at" class="tw:text-xs tw:text-zinc-500">
              {{ $t('Signed out at {time}', { time: dayjs(log.logout_at).format('lll') }) }}
            </span>
            <span v-else class="tw:text-zinc-400">—</span>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script setup>
import dayjs from 'dayjs'
import { Badge } from '@/components/ui/badge'
import UserAvatar from '@/components/user/UserAvatar.vue'

defineProps({
  logs: {
    type: Array,
    required: true,
  },
  // Hidden when the list is already pinned to one user, as on the user edit screen.
  showUser: {
    type: Boolean,
    default: true,
  },
})

// Same format as User::name on the server: "Firstname LASTNAME".
const userName = (user) => `${user.first_name} ${user.last_name?.toUpperCase() ?? ''}`.trim()
</script>
